import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  Row,
  Table,
  Col,
} from "reactstrap";

import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "../reports.scss";

// import "../app-invoice.css";
import { getSRTimelLineDocReport } from "../../../store/Reports/actions";
import SLE_logo from "../../../assets/images/SriLalitha_Logo.png";

class SRTimelLineReportDocument extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    console.log(
      "@SRTimelLineReportDocument - componentDidMount: Calling getSRTimelLineDocReport with ID:",
      this.props.match.params.id,
    );
    this.props.getSRTimelLineDocReport(this.props.match.params.id);
  }
  formatDate = (date) => (date ? moment(date).format("DD-MM-YYYY") : "-");

  getPDFReport = async () => {
    const element = document.getElementById("toPdf");
    if (!element) return;

    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      scrollX: 0,
      scrollY: 0,
      windowWidth: element.scrollWidth,
      windowHeight: element.scrollHeight,
      backgroundColor: "#ffffff",
    });

    const imgData = canvas.toDataURL("image/png");
    const pxToMm = 25.4 / 96;
    const imgWidthMM = canvas.width * pxToMm;
    const imgHeightMM = canvas.height * pxToMm;

    const scale = pageWidth / imgWidthMM;
    const scaledWidth = imgWidthMM * scale;
    const scaledHeight = imgHeightMM * scale;

    let yPos = 0;
    let xPos = 0;
    let remainingHeight = scaledHeight;
    let remainingWidth = scaledWidth;

    while (remainingHeight > 0) {
      while (remainingWidth > 0) {
        pdf.addImage(imgData, "PNG", -xPos, -yPos, scaledWidth, scaledHeight);

        remainingWidth -= pageWidth;
        xPos += pageWidth;

        if (remainingWidth > 0) pdf.addPage();
      }

      remainingWidth = scaledWidth;
      xPos = 0;
      remainingHeight -= pageHeight;
      yPos += pageHeight;

      if (remainingHeight > 0) pdf.addPage();
    }

    pdf.save("mrtimeline_report.pdf");
  };

  componentDidUpdate() {
    console.log(
      "@SRTimelLineReportDocument - componentDidUpdate: SR Code ID:",
      this.props.match.params.id,
    );
    console.log(
      "@SRTimelLineReportDocument - componentDidUpdate: SRTimeLine_Doc_report data:",
      this.props.SRTimeLine_Doc_report,
    );
  }
 

  reportBody() {
    const data = this.props.SRTimeLine_Doc_report;
    if (!data) return null;

    return (
      <Row className="p-1 report-preview">
        <Col md={12} className="p-1">
          <Card className="p-1 report-preview-card">
            <CardBody className="report-padding pb-0">
              {/* HEADER */}
              <div className="report-body flex-sm-row flex-column mt-0">
                <div>
                  <h5 className="card-title-16 pt-2">
                    SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD
                  </h5>
                  <p className="card-title-14 pt-2 mb-0">
                    Valuthimmapuram Road, PEDDAPURAM - 533437
                  </p>
                  <p className="card-title-14 pt-2">GSTIN : 37AAKCS3233N1ZX</p>
                </div>

                <div className="pt-2 text-right">
                  <img
                    className="img-fluid"
                    src={SLE_logo}
                    alt="Logo"
                    width="100"
                  />
                  <h4 className="report-title mb-0">SR TIMELINE REPORT</h4>
                  <h5>#{data.sr_no}</h5>
                </div>
              </div>

              <hr className="hr-black-color" />

              {/* BASIC DETAILS */}
              <div className="report-body d-flex justify-content-between">
                <div>
                  <p>
                    <strong>Location :</strong> {data.location_name || "-"}
                  </p>
                  <p>
                    <strong>SR Date :</strong> {data.sr_date || "-"}
                  </p>
                  <p>
                    <strong>Department :</strong> {data.department || "-"}
                  </p>
                </div>

                <div>
                  <p>
                    <strong>Created By :</strong> {data.user || "-"}
                  </p>
                  <p>
                    <strong>Quantity :</strong> {data.qty || "-"}
                  </p>
                  <p>
                    <strong>Item :</strong> {data.item_name || "-"}
                  </p>
                </div>
              </div>

               <hr className="hr-black-color" />
             
                         {/* ITEM DETAILS */}
                         <Table bordered className="table-centered">
                           <thead className="bg-light text-center">
                             <tr>
                               <th>S.NO</th>
                               <th>Item Name</th>
                               <th>Quantity</th>
                               <th>Current Status</th>
                             </tr>
                           </thead>
                           <tbody>
                             <tr>
                               <td className="text-center">1</td>
                               <td>{data.item_name || "-"}</td>
                               <td className="text-center">{data.qty || "-"}</td>
                               <td className="text-center">{data.sr_item_status || data.srfq_item_status || "-"}</td>
                             </tr>
                           </tbody>
                         </Table>
             
                         <hr className="hr-black-color" />

              {/* TIMELINE TABLE */}
              <Table bordered>
                <thead className="bg-light text-center">
                  <tr>
                    <th>Stage</th>
                    <th>Code</th>
                    <th>Date</th>
                    <th>Responsible</th>
                    <th>Due Days</th>
                    <th>Status</th>
                  </tr>
                </thead>

                <tbody>
                  {/* SR HOD */}
                  <tr>
                    <td>SR HOD Approval</td>
                    <td>{data.sr_no || "-"}</td>
                    <td>{data.sr_hod_approved_date || "-"}</td>
                    <td>{data.sr_hod_approved_by || "-"}</td>
                    <td>-</td>
                    <td>{data.sr_item_status || "-"}</td>
                  </tr>

                  {/* Service Approval */}
                  <tr>
                    <td>Service Approval</td>
                    <td>-</td>
                    <td>{data.service_approved_date || "-"}</td>
                    <td>{data.service_approved_by || "-"}</td>
                    <td>{data.sr_to_service_approved_due_days ?? "-"}</td>
                    <td>{data.sr_item_status || "-"}</td>
                  </tr>

                  {/* Service Indent */}
                  <tr>
                    <td>Service Indent (SI)</td>
                    <td>{data.si_code || "-"}</td>
                    <td>{data.si_date || "-"}</td>
                    <td>
                      <div>
                        <strong>Created :</strong> {data.si_created_by || "-"}
                      </div>
                      <div>
                        <strong>Approved :</strong> {data.si_approved_by || "-"}
                      </div>
                    </td>
                    <td>{data.sr_to_si_due_days ?? "-"}</td>
                    <td>{data.si_item_status || "-"}</td>
                  </tr>

                  {/* Service RFQ */}
                  <tr>
                    <td>Service RFQ</td>
                    <td>{data.srfq_no || "-"}</td>
                    <td>{data.srfq_date || "-"}</td>
                    <td>-</td>
                    <td>{data.si_to_srfq_due_days ?? "-"}</td>
                    <td>{data.srfq_item_status || "-"}</td>
                  </tr>

                  {/* Work Order */}
                  <tr>
                    <td>Work Order (WO)</td>
                    <td>{data.wo_no || "-"}</td>
                    <td>{data.wo_date || "-"}</td>
                    <td>{data.wo_created_by || "-"}</td>
                    <td>{data.srfq_to_wo_due_days ?? "-"}</td>
                    <td>{data.wo_status || "-"}</td>
                  </tr>

                  {/* Completion */}
                  <tr>
                    <td>WO Completion</td>
                    <td>-</td>
                    <td>{data.wo_completion_date || "-"}</td>
                    <td>
                      <strong>Vendor :</strong> {data.vendor_name || "-"}
                    </td>
                    <td>{data.wo_to_completion_due_days ?? "-"}</td>
                    <td>{data.wo_status || "-"}</td>
                  </tr>
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Row>
              <Col md={12}>
                <Card>
                  <CardHeader className="bg-transparent border-bottom no-print ">
                    <Link
                      to="#"
                      onClick={() => this.props.history.goBack()}
                      className="action-icon text-primary mr-2"
                    >
                      <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                    </Link>
                    <div className="float-right">
                      <div className="d-inline-block ">
                        <Button
                          type="button"
                          outline
                          color="secondary"
                          className=" mr-2"
                          onClick={() => this.getPDFReport()}
                        >
                          <i className="ri-file-excel-2-line"></i>
                          <span className="d-none d-inline-block ml-1">
                            PDF
                          </span>
                        </Button>

                        <Button
                          type="button"
                          outline
                          color="secondary"
                          className=" mr-2"
                          onClick={() => window.print()}
                        >
                          <i className="mdi  mdi-printer"></i>
                          <span className="d-none d-inline-block ml-1">
                            Print
                          </span>
                        </Button>
                      </div>
                    </div>
                  </CardHeader>
                  <CardBody className="pt-1 mr-auto mx-auto" id="toPdf">
                    {this.reportBody()}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { SRTimeLine_Doc_report } = state.reports;
  return {
    SRTimeLine_Doc_report,
  };
};

export default connect(mapStatetoProps, {
  getSRTimelLineDocReport,
})(SRTimelLineReportDocument);
